// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuItem_wrapper__Xceh4"};